/**
 * Apollo 4 rejects a failed mutation promise even when the mutation's `onError` already handled it.
 * Apollo 3 resolved with no data in that case. Wrap the mutation call in hooks that surface the failure
 * through `onError`, so their callers keep receiving `{ data: undefined }` instead of a rejection.
 *
 * Any rejection of the wrapped mutation is swallowed (Apollo calls `onError` before it rejects), so only use this
 * where the mutation defines `onError` and the caller does not need to react to the failure itself.
 */
export const ignoreHandledMutationError = <TResult extends { data?: unknown }>(mutation: Promise<TResult>) =>
  mutation.catch((): { data: undefined } => ({ data: undefined }));
